<template>
    <v-card flat>
        <v-card-text>
            <Search @search="params = $event" :loading="loading" class="mb-3"/>
            <v-card outlined elevation="4">
                <template v-if="list.length">
                    <v-card-title class="d-flex justify-space-between">
                        <div>
                            {{ list.length }} JUEGOS
                        </div>
                    </v-card-title>
                    <v-divider/>
                </template>
                <v-card-text>
                    <template v-if="loading">
                        <v-card outlined>
                            <v-card-text class="text-center">
                                <v-progress-circular indeterminate color="primary"/>
                                <div>Cargando</div>
                            </v-card-text>
                        </v-card>
                    </template>
                    <template v-else>
                        <template v-if="list.length">
                            <Item 
                                v-for="(juego, index) of list" 
                                :key="`juego-list-item-${index}-${juego.id}`" 
                                :juego="juego" 
                                class="mb-2"
                                />
                        </template>
                        <template v-else>
                            <v-card outlined>
                                <v-card-text class="d-flex justify-center">
                                    No hay resultados para la búsqueda
                                </v-card-text>
                            </v-card>
                        </template>
                    </template>
                </v-card-text>
            </v-card>
        </v-card-text>
    </v-card>
</template>
<script>
import JuegoService from '@services/operadora/loteria/JuegoService';

import Search from './search';
import Item from './item';

export default {
    components: {
        Item,
        Search
    },
    data: function () {
        return {
            loading: false,
            list: [],
            params: {
                is_active: true,
            }
        };
    },
    computed: {
    },
    mounted: function () {
        this.fetchList();
    },
    methods: {
        fetchList: function (params = {}) {
            this.loading = true;
            this.list = [];
            console.log({...this.params});
            JuegoService.getList({...this.params, ...params})
                .then(({ juegoList }) => {
                    this.list = juegoList;
                }).finally(() => {
                    this.loading = false;
                });
        },
    },
    watch: {
        params: function () {
            this.fetchList();
        },
    },
}
</script>